export type SettingResult = {
    key: string;
    value: string;
};

export type UpdateSettingValueRequest = {
    key: string;
    value: string;
};

export const SettingKeys = {
    EmailTemplateId: 'EmailTemplateId',
    ExaminerRewards: 'ExaminerRewards',
    RefereeRewards: 'RefereeRewards',
    Subject: 'Subject',
    TemplatePortalLink: 'TemplatePortalLink',
    ScientificSpecializationLookupsOtherId:"ScientificSpecializationLookupsOtherId",
    HelpLink: 'HelpLink',
};